import { useQuery } from "react-query";

import { fetchFindingCounts } from "@api";
import { useFindingFilters } from "@hooks/useFindingFilters";
import { useOrg } from "@hooks/useOrg";
import { useTimeLookbackRange } from "@hooks/useTimeLookbackRange";
import { timeLookbackRangeToSince } from "@utils";

/*
 * This hook returns the counts of findings for the current org
 */
export const useFindingCounts = () => {
  const org = useOrg();
  const { tlr } = useTimeLookbackRange();
  const { findingFilters } = useFindingFilters();

  const search = new URLSearchParams();

  if (findingFilters) {
    Object.entries(findingFilters).forEach(([key, value]) => {
      if (key === "tab") return;
      if (value) {
        search.set(key, String(value));
      }
    });
  }
  const search_without_since = search.toString();
  if (tlr) {
    // still pass since to the backend
    search.set("since", String(timeLookbackRangeToSince(tlr)));
  }
  return useQuery(
    // reload on changes to tlr and filters, but not on changes to since
    ["FindingCounts", { org }, tlr, search_without_since],
    () => fetchFindingCounts(org?.id!, search),
    { enabled: !!org && !!tlr && Object.keys(findingFilters).length > 0 }
  );
};
